module.exports = __webpack_public_path__ + "img/not-authorized.e9c47c33.svg";